// third-party
import { createSlice } from '@reduxjs/toolkit';

// project imports
import { dispatch } from '../index';

import { listCareSessions } from 'api/patient';
import * as alertSnackbar from 'utils/snackbar-wrapper';

// ----------------------------------------------------------------------

const initialState = {
    refreshTrigger: 0,
    careSessionList: {
        error: false,
        loaded: false,
        careSessions: [],
        careMetadata: {
            durationSeconds: {
                total: 0,
                ccm: 0,
                hrm: 0,
                rpm: 0
            },
            counts: {
                total: 0,
                ccm: 0,
                hrm: 0,
                rpm: 0
            },
            pageSize: 20
        },
        assessmentDefinitions: []
    }
};

const slice = createSlice({
    name: 'careSessionList',
    initialState,
    reducers: {
        triggerCareListRefresh(state) {
            state.refreshTrigger += 1;
        },
        setCareSessionListLoading(state) {
            state.careSessionList.loaded = false;
        },
        setCareSessionList(state, action) {
            state.careSessionList.error = false;
            state.careSessionList.loaded = true;
            state.careSessionList.careSessions = action.payload.careSessions;
            state.careSessionList.careMetadata = action.payload.careMetadata;
            state.careSessionList.assessmentDefinitions = action.payload.assessmentDefinitions;
        },
        setCareSessionListError(state) {
            state.careSessionList.error = true;
        },

        resetState(state) {
            state.careSessionList = initialState.careSessionList;
        }
    }
});

// Reducer
export default slice.reducer;

// ----------------------------------------------------------------------

export function resetState() {
    dispatch(slice.actions.resetState());
}

export function triggerCareListRefresh() {
    dispatch(slice.actions.triggerCareListRefresh());
}

/*
params.from / params.to are inclusive calendar days ('2026-09-18'), undefined
when the filter is not set. The server resolves them to day boundaries in the
app zone, so the browser's zone does not change which events a range covers.
*/
export function getCareSessionList(patientId, params) {
    return async () => {
        try {
            dispatch(slice.actions.setCareSessionListLoading());
            const response = await listCareSessions(patientId, params);
            dispatch(slice.actions.setCareSessionList(response.data));
        } catch (error) {
            dispatch(alertSnackbar.error('Failed to fetch care timeline'));
            dispatch(slice.actions.setCareSessionListError());
        }
    };
}
